import { EnvConfig } from '@config';
import { ApiResponse } from 'types/apiResponse';
import { UnitSystems } from 'types/unitSystem';
import { FavouriteWells, UserDTO } from 'types/user';

import Client from './client';

const userAccessApiBaseUrl = EnvConfig.drillx_so_admin_user_management_backend || '';
const accept = 'application/json';

// TODO: Once the merge of the microservices is finished, rename / merge this
class UserApiClient {
  client: Client;

  constructor() {
    this.client = new Client(userAccessApiBaseUrl, accept);
  }

  getUser = async (): Promise<ApiResponse<UserDTO | null>> => {
    try {
      const user = await this.client.get('/users/me');
      // TODO: catch 401 and redirect to login page

      return { response: user };
    } catch (error) {
      throw error;
    }
  };

  patchUserUnitSystem = async (unitSystemId: UnitSystems): Promise<UserDTO | null> => {
    try {
      const user: UserDTO = await this.client.patch('/users/me/unit-system', { unitSystemId });

      return user;
    } catch (error) {
      return null;
    }
  };

  patchUserFavouriteWells = async (favouriteWells: FavouriteWells): Promise<UserDTO | null> => {
    try {
      const response = await this.client.patch('/users/me/favourite-wells', { favouriteWells });

      return response;
    } catch (error) {
      return null;
    }
  };

  getUsers = async (): Promise<UserDTO[]> => {
    try {
      const users = await this.client.get('/users');

      return users;
    } catch (error) {
      return [];
    }
  };

  createUser = async (user: Partial<UserDTO>): Promise<UserDTO | null> => {
    try {
      const createdUser = await this.client.post('/users', user);

      return createdUser;
    } catch (error) {
      return null;
    }
  };

  deleteUser = async (igg: string): Promise<boolean> => {
    try {
      await this.client.delete(`/users/${igg}`);

      return true;
    } catch (error) {
      return false;
    }
  };

  updateUser = async (
    igg: string,
    body: Record<string, number | string>,
  ): Promise<UserDTO | null> => {
    try {
      const user = await this.client.patch(`/users/${igg}`, body);

      return user;
    } catch (error) {
      return null;
    }
  };
}

export default new UserApiClient();
